import angular from 'angular';

import AUTH_EVENTS from './constants/authEvents.constant';
import AUTH_ROUTES from './constants/authRoutes.constant';
import httpProviderConfig from './configs/httpProvider.config';
import authContainer from './containers/auth.container';
import accountSelectorContainer from './containers/accountSelector.container';
import loginContainer from './containers/login.container';
import rememberPasswordContainer from './containers/rememberPassword.container';
import resetPasswordContainer from './containers/resetPassword.container';
import successContainer from './containers/success.container';
import unauthorizedContainer from './containers/unauthorized.container';
import accountSelector from './components/accountSelector/accountSelector.component';
import login from './components/login/login.component';
import rememberPassword from './components/rememberPassword/rememberPassword.component';
import resetPassword from './components/resetPassword/resetPassword.component';
import unauthorized from './components/unauthorized/unauthorized.component';
import routeProviderConfig from './configs/routeProvider.config';
import Auth from './services/auth';
import AuthRoutesManager from './services/authRoutesManager';
import SSOAuthInterceptor from './services/ssoAuthInterceptor';
import SSOClient from './services/ssoClient';
import SSOErrors from './services/ssoErrors';
import SSOState from './services/ssoState';
import SSOStorage from './services/ssoStorage';
import SSOValidation from './services/ssoValidation';
import restartAuthentication from './eventsSubscribers/restartAuthentication';

import './assets/scss/authBox.scss';

/**
 * This module provides all the containers, components and services needed for user
 * authentication.
 * @ngesdoc module
 * @ngname auth
 */
const authModule = angular.module('auth', [])
.constant('AUTH_ROUTES', AUTH_ROUTES)
.constant('AUTH_EVENTS', AUTH_EVENTS)
.config(httpProviderConfig)
.config(routeProviderConfig)
.component('authContainer', authContainer)
.component('accountSelectorContainer', accountSelectorContainer)
.component('loginContainer', loginContainer)
.component('rememberPasswordContainer', rememberPasswordContainer)
.component('resetPasswordContainer', resetPasswordContainer)
.component('successContainer', successContainer)
.component('unauthorizedContainer', unauthorizedContainer)
.component('accountSelector', accountSelector)
.component('login', login)
.component('rememberPassword', rememberPassword)
.component('resetPassword', resetPassword)
.component('unauthorized', unauthorized)
.service('auth', Auth)
.service('authRoutesManager', AuthRoutesManager)
.service('ssoAuthInterceptor', SSOAuthInterceptor)
.service('ssoClient', SSOClient)
.service('ssoErrors', SSOErrors)
.service('ssoState', SSOState)
.service('ssoValidation', SSOValidation)
.service('ssoStorage', SSOStorage)
.run(restartAuthentication);

export default authModule.name;
